import { forwardRef, type InputHTMLAttributes } from "react";
import { cn } from "../lib/cn";
import { focusRing, hoverTransition } from "../lib/styles";

export interface InputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "className"> {
  /** Marks the field invalid and wires aria-invalid; the message lives in <Field>. */
  invalid?: boolean;
  /** doc 41 §3: identifiers get tabular numerals plus 0.01em tracking. */
  identifier?: boolean;
  className?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { invalid = false, identifier = false, className, ...rest },
  ref,
) {
  return (
    <input
      ref={ref}
      aria-invalid={invalid || undefined}
      className={cn(
        // border-control, not border-default: an input's boundary is required
        // to identify the control, so it needs the >=3:1 token (doc 40 §14).
        "h-9 w-full rounded-sm border bg-default px-3 text-sm text-default",
        "placeholder:text-placeholder disabled:cursor-not-allowed disabled:bg-subtle disabled:text-disabled",
        invalid ? "border-danger" : "border-control",
        identifier && "identifier",
        focusRing,
        hoverTransition,
        className,
      )}
      {...rest}
    />
  );
});
